import { FormContext, iChoice, iControlProps } from "../types";
import React, { useEffect, useState } from "react";

import Select from "./select";

type TableDropdownProps = iControlProps & {
    context: FormContext;
    formId: number;
    fieldId: number;
};

type optionWithGroup = {
    label: string;
    value: string;
    group?: string;
};

const TableDropdown = ({
    formId,
    fieldId,
    context,
    onChange,
    ...props
}: TableDropdownProps) => {
    const [choices, setChoices] = useState<iChoice[]>([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_TABLES}/${formId}/${fieldId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then((data: { success: boolean; options?: optionWithGroup[] }) => {
                let options: iChoice[] = [];

                if (data.options) {
                    options = data.options.reduce(
                        (
                            groupedOptions: iChoice[],
                            option: optionWithGroup
                        ) => {
                            const newOption = {
                                text: option.label,
                                value: option.value
                            };
                            if (option.group) {
                                const groupKey = groupedOptions.findIndex(
                                    groupedOption =>
                                        groupedOption.text === option.group
                                );
                                if (groupKey !== -1) {
                                    groupedOptions[groupKey].options?.push(
                                        newOption
                                    );
                                } else {
                                    groupedOptions.push({
                                        text: option.group,
                                        options: [newOption]
                                    });
                                }
                            } else {
                                groupedOptions.push(newOption);
                            }
                            return groupedOptions;
                        },
                        []
                    );
                }
                setChoices(options);
            });
    }, [formId, fieldId]);

    const accessibilitySettings: { [key: string]: string } = {};
    props.accessibilitySettings &&
        props.accessibilitySettings.forEach(setting => {
            if (setting.isShown)
                accessibilitySettings[setting.name] = setting.value || "";
        });
    return (
        <Select
            {...{
                ...props,
                onChange: (newValue: string) => {
                    onChange && onChange(newValue);
                },
                choices
            }}
            {...accessibilitySettings}
        />
    );
};

export default TableDropdown;
